module.exports = __webpack_public_path__ + "montaj.jpg?702f72ccf635d7adf91ec12e88d06068";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/montaj.jpg
// module id = 320
// module chunks = 0